<ng-container *ngIf="url">
    <img [ngStyle]="imgStyle" [matTooltip]="username" alt="user avatar" [src]="url" (error)="handleError($event)">
</ng-container>

<ng-container *ngIf="!url">
    <mat-spinner class="pointer" [diameter]="spinnerDiameter"></mat-spinner>
</ng-container>
